import { isEmpty } from "lodash";
import React, { useState } from "react";
import Select from "react-dropdown";
import CS from "../../../services/commonService";
import {
	addCategorySchema,
	updateCategorySchema,
} from "../../../validations/categoriesValidations";
import {
	useAddFoodCategories,
	useUpdateFoodCategories,
} from "../../../queryHooks/useCategories";
import { useEffect } from "react";
import UploadAndCropImageModal from "../../common/UploadAndCropImageModal";
import { useFormik } from "formik";
import dataUrlToFile from "../../common/urlToFile";
import { useStore } from "../../../zustand/store";
import EmojiPicker from "emoji-picker-react";
//  Component starts
const AddUpdate = ({ category, onCloseModal, getCategories }) => {
	const setLoading = useStore((state) => state.setLoading);
	//	Pre-defined values
	if (isEmpty(category)) category = { title: "" };
	const statusOptions = [
		{ value: 1, label: "Active" },
		{ value: 0, label: "Inactive" },
	];
	//	State values
	const [status, setStatus] = useState(
		statusOptions.find((option) => option.value === category.is_featured) || {
			value: 1,
			label: "Active",
		}
	);
	const [photo, setPhoto] = useState(category.image_url);
	const [file, setFileData] = useState();
	const [cropAndUploadImageModel, setCropAndUploadImageModel] = useState(false);
	const [emojiPicker, setEmojiPicker] = useState(false);

	const [formData] = useState({
		name: category.name,
		is_featured: status.value,
		photo: category.image_url,
		emoji: category.emoji,
	});

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: formData,
		validationSchema: category.id ? updateCategorySchema : addCategorySchema,
		onSubmit: (value) => {
			if (category.id) {
				const fileData = new FormData();
				if (file) {
					fileData.append("category_picture", file);
				}
				fileData.append("is_featured", status.value === 1 ? true : false);
				fileData.append("emoji", value.emoji);
				const obj = {
					fileData: fileData,
					id: category.id,
				};
				updateFoodCategories(obj);
				setLoading(true);
			} else {
				const fileData = new FormData();
				fileData.append("category_picture", file);
				fileData.append("is_featured", status.value === 1 ? true : false);
				fileData.append("name", value.name?.trim());
				fileData.append("emoji", value.emoji);
				addCategory(fileData);
				setLoading(true);
			}
		},
	});

	/***********************
	 * Add categories
	 ***************************/

	const {
		mutateAsync: addCategory,
		error: erroraddCategory,
		data: dataaddCategory,
	} = useAddFoodCategories();

	useEffect(() => {
		if (dataaddCategory) {
			setLoading(false);
			if (dataaddCategory.status === "success") {
				onCloseModal();
				getCategories();
				CS.showSuccessMessage(dataaddCategory.message);
			} else if (dataaddCategory.status === "fail") {
				CS.showErrorMessage(dataaddCategory.message);
			}
		}
	}, [dataaddCategory]);

	useEffect(() => {
		if (erroraddCategory) {
			setLoading(false);
			CS.showErrorMessage(erroraddCategory.response?.data?.message);
		}
	}, [erroraddCategory]);

	/******************************************************************************************
    @Purpose    :   Update categories
    *******************************************************************************************/

	const {
		mutateAsync: updateFoodCategories,
		error: errorUpdateFoodCategories,
		data: dataUpdateFoodCategories,
	} = useUpdateFoodCategories();

	useEffect(() => {
		if (dataUpdateFoodCategories) {
			setLoading(false);
			if (dataUpdateFoodCategories.status === "success") {
				onCloseModal();
				getCategories();
				CS.showSuccessMessage(dataUpdateFoodCategories.message);
			} else if (dataUpdateFoodCategories.status === "fail") {
				CS.showErrorMessage(dataUpdateFoodCategories.message);
			}
		}
	}, [dataUpdateFoodCategories]);

	useEffect(() => {
		if (errorUpdateFoodCategories) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateFoodCategories.response?.data?.message);
		}
	}, [errorUpdateFoodCategories]);

	const handleImageCropped = async (image) => {
		if (image) {
			handleChange({ target: { name: "photo", value: image } });
			const fileObj = dataUrlToFile(image);
			setFileData(fileObj);
			setPhoto(image);
		}
	};

	const closeModal = async () => {
		setCropAndUploadImageModel(false);
	};

	useEffect(() => {
		setLoading(false);
		if (!category.id && cropAndUploadImageModel) {
			setPhoto(null);
		}
	}, [cropAndUploadImageModel]);

	return (
		<div className="modal-dialog modal-dialog-scrollable m-0 w-100">
			<div className="modal-content">
				<div className="modal-header">
					<h5 className="modal-title">
						{" "}
						{category.id ? "Update Category" : "Add Category"}
					</h5>
				</div>
				<div className="notification-form modal-body card profile-card password-modal">
					<div className="row">
						<div className="col-md-12">
							<form onSubmit={(event) => handleSubmit(event)}>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										{/* <label className="label xl-label">Logo</label> */}
										<div className="edit-image ml-0">
											<div
												className="user-image"
												onClick={() => setCropAndUploadImageModel(true)}
											>
												{CS.renderImageUrl(photo, "other", true)}
												<span
													style={{
														color: "red",
														position: "absolute",
														bottom: "0%",
														fontSize: "13px",
													}}
													id="restaurentsImage"
												></span>
												<label
													className="img-upload"
													htmlFor="attach-file"
													onClick={() => setCropAndUploadImageModel(true)}
												>
													<em className="bx bxs-edit-alt" />
												</label>
											</div>
											<UploadAndCropImageModal
												show={cropAndUploadImageModel}
												handleImageCropped={handleImageCropped}
												handleClose={closeModal}
												aspect={false}
											/>
										</div>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.photo && touched.photo ? errors.photo : null}
											</span>
										</div>
									</div>
									<div className="form-group mb-0">
										<label className="label xl-label" htmlFor="title">
											Category Name<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<input
												className="form-control"
												type="text"
												id="name"
												name="name"
												placeholder="Enter category name"
												disabled={category.id ? true : false}
												value={values.name}
												onChange={handleChange}
											/>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.name && touched.name ? errors.name : null}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Status<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<Select
												value={status}
												onChange={(option) => setStatus(option)}
												options={statusOptions}
											/>
										</div>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.is_active && touched.is_active
													? errors.is_active
													: null}
											</span>
										</div>
									</div>
								</div>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Emoji<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<input
												readOnly
												className="form-control cursor-pointer"
												type="text"
												id="emoji"
												name="emoji"
												placeholder="Select an emoji"
												value={values.emoji}
												onClick={() => setEmojiPicker(!emojiPicker)}
											/>
											{emojiPicker && (
												<EmojiPicker
													width="100%"
													height="300px"
													onEmojiClick={(e) => {
														handleChange({
															target: { name: "emoji", value: e.emoji },
														});
														setEmojiPicker(false);
													}}
												/>
											)}
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.emoji && touched.emoji ? errors.emoji : null}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="mt-5 text-right">
									<button className="btn btn-primary" type="submit">
										{category.id ? "Update" : "Add"}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddUpdate;
